

















































































import {
  IResource,
  $, WholeCollection, cnpj, ObjectCollection,
} from 'simpli-web-sdk'
import {Component, Prop, Mixins} from 'vue-property-decorator'
import {MixinMember} from '@/components/mixins/MixinMember'
import {ItrackCollection} from '@/helpers'
import CargaDestinatario from '@/model/resource/CargaDestinatario'
import {Period} from '@/enums/Period'
import DeliveryReceiverRequest from '@/model/request/DeliveryReceiverRequest'

@Component
export default class FilterDeliveryReceiver extends Mixins(MixinMember) {
  @Prop({required: true}) value!: DeliveryReceiverRequest

  Period = Period

  allReceiver  = ItrackCollection.allReceiver

  async mounted() {
    await this.allReceiver.query()
    await this.value.allCentroDeCusto.query()
    await this.value.allTipoInsumo.query()
  }

  get cnpjResource() {
      return this.allReceiver.get(this.value.cpfCnpj)
  }
  set cnpjResource(val: CargaDestinatario | null) {
      this.value.cpfCnpj = val && val.$id as string || null
  }

  get valueComputed() {
    return this.value
  }

  set valueComputed(val) {
    this.$emit('input', val)
  }

  formatSigla() {
    if (this.value.sigla) {
      this.value.sigla = this.value.sigla.toUpperCase()
    }
  }
}
